import { atom } from "jotai";

const REFRESH_TOKEN = "REFRESH_TOKEN";
const ACCESS_TOKEN = "ACCESS_TOKEN";

const accessToken = atom(localStorage.getItem(ACCESS_TOKEN) ?? "");
const refreshToken = atom(localStorage.getItem(REFRESH_TOKEN) ?? "");

export const accessTokenAtom = atom(
  (get) => get(accessToken),
  (_get, set, newVal: string) => {
    set(accessToken, newVal);
    localStorage.setItem(ACCESS_TOKEN, newVal);
  }
);

export const refreshTokenAtom = atom(
  (get) => get(refreshToken),
  (_get, set, newVal: string) => {
    set(refreshToken, newVal);
    localStorage.setItem(REFRESH_TOKEN, newVal);
  }
);
